<div
    class="on-parent-scroll"
    [ngClass]="{
        'dynamic-scroll-height':
            !displayProperties || !displayProperties.stopScrollHeight
    }"
>
    <cmps-wait-status *ngIf="state?.pending?.reload"></cmps-wait-status>

    <div
        class="text-center"
        *ngIf="!state?.pending?.reload && !state?.event"
    >
        {{ _i18n._704_UNKNOWN_ERROR | translate }}
    </div>

    <ng-container
        [formGroup]="_form.form"
        *ngIf="!state?.pending?.reload && state?.event"
    >
        <div class="container on-header">
            <div
                class="row"
                data-e2e="area-messages"
            >
                <!--TODO create something more elaborate-->
                <div
                    class="col-12 notification"
                    (click)="_onDismissMessageClick()"
                    *ngIf="state?.justSaved"
                >
                    <h6 class="notification-success text-left">
                        {{ _i18n._9706_THE_OBSERVATION_WAS_SAVED_ | translate }}
                    </h6>
                </div>
                <div
                    class="d-flex align-items-center w-100 alert-warning-compas"
                    data-e2e="alert-start-time"
                    *ngIf="_form.errors['START_TIME']"
                >
                    <cmps-icon svgIcon="alert"></cmps-icon>
                    <div class="h6 m-0 ml-2 text-white">
                        {{ _form.errors['START_TIME'] }}
                    </div>
                </div>
                <div
                    class="d-flex align-items-center w-100 alert-warning-compas"
                    *ngIf="_form.errors['DURATION']"
                >
                    <cmps-icon svgIcon="alert"></cmps-icon>
                    <div class="h6 m-0 ml-2 text-white">
                        {{ _form.errors['DURATION'] }}
                    </div>
                </div>
            </div>

            <div
                class="row mb-2"
                *ngIf="mode === _ObservationMode.DEFAULT"
            >
                <div
                    cmpsObservationController
                    [published]="state?.event?.published"
                    [allowedActions]="state?.allowedActions"
                    [enabledActions]="state?.enabledActions"
                    [pending]="pendingAny"
                    [dirty]="dirty"
                    (cancel)="cancel()"
                    (delete)="delete()"
                    (share)="share()"
                    (publish)="publish()"
                    (save)="save()"
                ></div>
            </div>

            <div class="row">
                <!--TODO styles still need to be revised-->
                <div
                    class="col d-flex align-items-center justify-content-between"
                >
                    <div
                        class="d-inline-flex align-items-center"
                        [class.d-flex]="!_untaggedTagGroupIsVisible"
                        *ngIf="
                            (!_readonly || _readonly.value === false) &&
                            !state?.event?.published &&
                            (focus?.behaviourId == null ||
                                mode !== _ObservationMode.POP_UP)
                        "
                    >
                        <button
                            cmpsButton
                            [disabled]="_untaggedTagGroupIsVisible"
                            [attr.aria-label]="
                                _i18n._9625_CREATE_A_NEW_FOCUS | translate
                            "
                            (click)="_onCreateFocusContainerClick()"
                        >
                            <cmps-icon
                                svgIcon="image-filter-center-focus-strong"
                            ></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._9625_CREATE_A_NEW_FOCUS | translate
                            }}</span>
                        </button>
                    </div>
                    <div class="d-inline-flex align-items-center">
                        <div>{{ _i18n._9419_TYPE_ | translate }}&nbsp;</div>
                        <div *ngIf="_readonly && _readonly.value === true">
                            <!--TODO simplify this-->
                            <ng-container
                                *ngFor="let option of _deliveryTypeOpts"
                            >
                                <div
                                    *ngIf="
                                        option.value ===
                                        _form.form.controls[
                                            _form.fields.DELIVERY_TYPE.name
                                        ].value
                                    "
                                >
                                    {{ option.label }}
                                </div>
                            </ng-container>
                        </div>
                        <div *ngIf="!_readonly || _readonly.value === false">
                            <ng-select
                                class="ng-select--variant-1 ng-select--variant-d"
                                [options]="_deliveryTypeOpts"
                                [noFilter]="999"
                                [ariaLabel]="_i18n._9419_TYPE_ | translate"
                                [formControlName]="
                                    _form.fields.DELIVERY_TYPE.name
                                "
                            ></ng-select>
                        </div>
                    </div>

                    <div class="d-inline-flex align-items-center">
                        <div>{{ _i18n._9420_STATUS_ | translate }}&nbsp;</div>
                        <cmps-observation-status
                            data-e2e="textbox-status"
                            [published]="state?.event?.published"
                        ></cmps-observation-status>
                    </div>

                    <div class="d-inline-flex align-items-center">
                        <div>
                            {{ _i18n._9497_DATE___TIME_ | translate }}&nbsp;
                        </div>
                        <div *ngIf="_readonly && _readonly.value === true">
                            {{
                                _form.form.controls[
                                    _form.fields.START_TIME.name
                                ].value | date: 'LLL-dd-yyyy, h:mm a'
                            }}
                        </div>
                        <div *ngIf="!_readonly || _readonly.value === false">
                            <div class="input-group text-nowrap">
                                <input
                                    class="form-control date-selector bg-white"
                                    [attr.aria-label]="
                                        _i18n._9497_DATE___TIME_ | translate
                                    "
                                    data-e2e="textbox-start-time"
                                    cmpsDateTimePicker
                                    [minDate]="_minDate"
                                    [maxDate]="_maxDate"
                                    #dtp="cmpsDateTimePicker"
                                    [formControlName]="
                                        _form.fields.START_TIME.name
                                    "
                                />
                                <div class="input-group-append">
                                    <button
                                        type="button"
                                        class="btn btn-secondary datepicker-toggle"
                                        aria-label="Toggle date picker"
                                        [attr.aria-expanded]="dtp.isOpen()"
                                        (click)="dtp.toggle()"
                                    >
                                        <cmps-icon
                                            class="formIcon"
                                            svgIcon="calendar-range"
                                        ></cmps-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-inline-flex align-items-center">
                        <div>{{ _i18n._9417_DURATION_ | translate }}&nbsp;</div>
                        <div *ngIf="_readonly && _readonly.value === true">
                            {{
                                _form.form.controls[_form.fields.DURATION.name]
                                    .value
                            }}
                        </div>
                        <div *ngIf="!_readonly || _readonly.value === false">
                            <!--min="1"
                            max="480"-->
                            <input
                                type="number"
                                class="form-control bg-white"
                                [class.ob-duration]="
                                    mode !== _ObservationMode.DEFAULT
                                "
                                [attr.aria-label]="
                                    _i18n._9417_DURATION_ | translate
                                "
                                [formControlName]="_form.fields.DURATION.name"
                            />
                        </div>
                    </div>

                    <div
                        cmpsObservationNavigator
                        [previousDisabled]="previousDisabled"
                        (previous)="previous.emit()"
                        [nextDisabled]="nextDisabled"
                        (next)="next.emit()"
                        *ngIf="
                            mode === _ObservationMode.REVIEW_READ_ONLY &&
                            (!displayProperties ||
                                !displayProperties.hideNavigator)
                        "
                    ></div>
                </div>
            </div>
        </div>

        <hr
            class="m-0 w-100"
            *ngIf="mode === _ObservationMode.DEFAULT"
        />

        <div
            class="on-container-scroll"
            [class.pt-3]="mode === _ObservationMode.DEFAULT"
        >
            <div
                cmpsObservationTagGroupsNext
                [storePathPrefix]="
                    storePathPrefix
                        ? storePathPrefix + '.coachingObservation'
                        : 'coachingObservation'
                "
                [displayProperties]="displayProperties"
                [observationId]="state?.event?.eventId"
                [published]="state?.event?.published"
                [performerId]="state?.performer?.userId"
                [focusSelectionParams]="
                    state?.coachingEvent?.focusSelectionParams
                "
                [newFocusSelectorWithYield]="
                    state?.coachingEvent?.newFocusSelectorWithYield
                "
                [interactionEntity]="state?.interactionEntity"
                [defaultInteractionTypeId]="state?.defaultInteractionTypeId"
                [defaultNoteCategory]="_NoteCategory.GENERAL"
                [allowedActions]="state?.allowedActions"
                [behaviours]="state?.behaviours"
                [subBehaviours]="state?.subBehaviours"
                [metrics]="state?.metrics"
                [filteredFocus]="filteredFocus"
                [isGeneric]="_isGeneric"
                [isFromCommitment]="
                    draftCommitmentId != null || commitmentId != null
                "
                [activeMetric]="_activeMetric"
                (upsertCommitment)="_onUpsertCommitment($event)"
                [extraOptions]="extraOptions"
                [formControlName]="_form.fields.TAG_GROUPS.name"
                (untaggedTagGroupIsVisible)="
                    _untaggedTagGroupIsVisible = $event
                "
            ></div>
        </div>
    </ng-container>
</div>
